import { DefaultAutocomplete } from "../../../../../../common/components/default_autocomplete";

import CascateList from "../../../../../../common/components/cascate_list";
import { TreinamentoTreinamentoCargo } from "../../../../domain/models/treinamento_treinamento_cargo";

/**
 * Header
 */

type Props = {
  selectedTreinamento: TreinamentoTreinamentoCargo | undefined,
  treinamentos: TreinamentoTreinamentoCargo[],
  onSelectTreinamento: (treinamento: TreinamentoTreinamentoCargo | null) => void,
};

export const Header = ({
  selectedTreinamento,
  treinamentos,
  onSelectTreinamento,
}: Props) => {
  return (
    <>
      <CascateList
        title="Selecione o treinamento"
        defaultOpen>
        <div className="w-full flex flex-col gap-6 items-center justify-center">
          <div className="w-full">
            <DefaultAutocomplete
              label='Treinamento'
              options={treinamentos}
              getOptionLabel={x => x.nome}
              getOptionKey={x => x.idTreinamento}
              value={selectedTreinamento}
              onChange={onSelectTreinamento} />
          </div>
        </div>
      </CascateList>
    </>
  );
}